import { Link } from "react-router-dom";

const stats = [
  { num: "2.3万+", label: "收录作品" },
  { num: "8大", label: "题材分类" },
  { num: "每日", label: "榜单更新" },
  { num: "9.7", label: "最高评分" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[560px] md:min-h-[620px] w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20Korean%20webtoon%20artwork%20collage%20of%20colorful%20comic%20pages%20floating%20in%20warm%20coral%20and%20golden%20light%2C%20young%20anime%20characters%2C%20dynamic%20ink%20brush%20strokes%2C%20manga%20panels%2C%20vibrant%20cream%20and%20amber%20palette%2C%20artistic%20editorial%20illustration%2C%20high%20detail%2C%20cinematic%20composition&width=1600&height=900&seq=hero-hanyy-01&orientation=landscape"
          alt="韩漫YY榜 人气韩漫精选背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-[1200px] px-4 md:px-6 py-20 md:py-24 text-center">
        <p className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill text-accent-400"></i>
          人气榜单 · 每日更新
        </p>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 sm:text-5xl md:text-6xl">
          一榜看懂<span className="text-accent-400">好韩漫</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          韩国漫画yy排行榜精选，韩漫人气榜单与完结漫画分类实时更新。新番抢先看，快速定位你想看的韩漫，追榜选书更高效。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/#ranking"
            className="w-full whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            查看人气榜单
          </Link>
          <Link
            to="/categories"
            className="w-full whitespace-nowrap rounded-md bg-background-50/15 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/25 sm:w-auto"
          >
            按题材选书
          </Link>
        </div>

        <div className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg bg-background-50/10 px-4 py-4 backdrop-blur">
              <div className="font-heading text-2xl text-accent-400 md:text-3xl">{s.num}</div>
              <div className="mt-1 text-xs text-background-100">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}